module.exports = "<my-dispatch-create-form my-dispatch=\"$$dispatch.data.myDispatch\"\n  enable-title=\"true\"\n  enable-back=\"true\">\n</my-dispatch-create-form>\n"


//////////////////
// WEBPACK FOOTER
// ./public/javascript/sygem/routing/consult/dispatch/templates/new.html
// module id = 1493
// module chunks = 0